export enum CallFlowStep {
  NotStarted = "notStarted",
  ValidateProvider = "validateProvider",
  ValidateAddress = "validateAddress",
  SubmitCallNotes = "submitCallNotes",
  CallFlowCompleted = "callFlowCompleted",
  EditCompleted = "editCompleted",
}
